import { render, staticRenderFns } from "./QuickNav.vue?vue&type=template&id=35cbe42a&scoped=true&"
import script from "./QuickNav.vue?vue&type=script&lang=js&"
export * from "./QuickNav.vue?vue&type=script&lang=js&"
import style0 from "./QuickNav.vue?vue&type=style&index=0&id=35cbe42a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cbe42a",
  null
  
)

export default component.exports